<template>
    <div class="respondlink">
        <div>
            <van-icon name="passed" />
            <p>提交成功</p>
            <img src="../../../assets/images/humanResting/totalnum@2x.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: "respondlink",
    data() {
        return {};
    },
    components: {},
    methods: {
        backChange() {
            window.history.pushState(null, null, '#');
        }
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, '#');
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
        }
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.backChange, false); //false阻止默认事件
    },
};
</script>

<style scoped lang="less">
@import '../asset/css/respondlink.less';
</style>
